/**
 * The label to display when selected the filter
 */
export const labelSpaziLavoratore = {
  mezzagiornata: 'Riposo',
  spazioConvivente: 'Spazi Lavoratore',
  spazioConvivenzaRidotta: 'Spazi Lavoratore ridotta',
};
